<ng-template #modalRation>
  <div id="ration-modal">
    <div class="modal-header d-flex bg-primary p-3 justify-content-between align-items-center">
      <div class="d-flex align-items-center flex-wrap p-2 border-header">
        <div class="d-none d-lg-flex align-items-center">
          <app-image-color
            [height]="'30px'"
            [width]="'40px'"
            [url]="'img/icons/racion.svg'"
            [color]="'#ffffff'"
          ></app-image-color>
          <app-spinner
            class="ml-3"
            *ngIf="!feeder"
            [smallLoader]="true"
            [spinnerColor]="'text-white'"
          ></app-spinner>
        </div>
        <div class="line bg-white d-none d-lg-flex"></div>
        <div class="text-left ml-2">
          <div class="flex-column">
            <h2 class="mb-0 d-flex align-items-start" *ngIf="feeder">
              {{ "ration-modal.ration-of" | translate }} {{ feeder.name }}
            </h2>
            <h2 class="mb-0 d-flex align-items-start" *ngIf="!feeder">
              {{ "ration-modal.ration-view" | translate }}
            </h2>
            <p class="m-0">{{ "ration-modal.subtitle" | translate }}</p>
          </div>
        </div>
      </div>

      <h3 class="m-0 c-pointer" (click)="closeModal()">&times;</h3>
    </div>
    <ng-container *ngIf="loading_data_pond; else content_modal">
      <app-spinner [vh]="'h-25vh'" [spinnerColor]="'text-primary'" [type]="'racion'"> </app-spinner>
    </ng-container>

    <ng-template #content_modal>
      <div class="modal-body">
        <div class="row justify-content-center">
          <ng-container *ngIf="feeder">
            <!-- Grafica de dieta, peso virtual y velocidad: no aplican en estanques
                   manejados por administracion para el cliente (el admin si las ve,
                   aunque este en modo cliente), ahi solo se muestra Envio/Alimento/Racion -->
            <ng-container *ngIf="!hideAdminManagedViews()">
              <div class="col-9 text-center" *ngIf="view === 'diet'">
                <ng-container *ngIf="validatingAdmin(feederAlert?.diet); else noAdmin">
                  <app-echar
                    [type]="'diet'"
                    [labels]="labelsGraph"
                    [data]="dataGraph"
                    [options]="optionsGraph"
                    [height]="500"
                    [heightStyle]="'px'"
                  ></app-echar>
                </ng-container>
                <ng-template #noAdmin>
                  <div class="center flex-column p-4">
                    <p>{{ "clients.diet.no-access" | translate }}</p>
                  </div>
                </ng-template>
              </div>
              <div class="col-12" *ngIf="view === 'food' && permissions.view_virtual_weight">
                <div class="center">
                  <app-virtual-weight
                    [label]="feeder.virtual_weight.left_kgs ? feeder.virtual_weight.left_kgs : 0"
                    [percent]="
                      feeder.virtual_weight.percentage ? feeder.virtual_weight.percentage : 0
                    "
                    [width]="300"
                    [height]="300"
                  ></app-virtual-weight>
                </div>
              </div>
              <div
                class="col-9 text-center"
                *ngIf="feeder && validateVersionSpeed(feeder) && view === 'speed'"
              >
                <app-speed-view-feeder [feeder]="feeder"></app-speed-view-feeder>
              </div>
            </ng-container>
            <div class="col-12">
              <div class="row mt-3 justify-content-center">
                <div
                  class="col-12 col-md-6 col-lg-4 col-xl-3 text-left"
                  *ngIf="feederAlert && feederAlert.user"
                >
                  <div class="card p-3 d-flex justify-content-center" style="min-height: 140px">
                    <div>
                      <h4 class="mb-0 mt-2">
                        {{ "ration-modal.sending" | translate }}
                      </h4>
                    </div>
                    <div class="mt-2">
                      <div class="d-flex justify-content-between mt-2">
                        <div style="width: 50%">
                          <p class="m-0">{{ "ration-modal.sent-by" | translate }}</p>
                          <h4>
                            {{ feederAlert.user ? feederAlert.user.username : "??" }}
                          </h4>
                        </div>
                        <div style="width: 50%">
                          <p class="m-0">{{ "ration-modal.sent-at" | translate }}</p>
                          <h4>
                            {{ getRationSentDate() | date : "medium" }}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4 col-xl-3 text-left" *ngIf="feederAlert.food">
                  <div class="card p-3 d-flex justify-content-center" style="min-height: 140px">
                    <div>
                      <h4 class="mb-0 mt-2">
                        {{ "ration-modal.food" | translate }}
                      </h4>
                    </div>
                    <div class="mt-2" *ngIf="feederAlert.food">
                      <div class="d-flex justify-content-between mt-2">
                        <div style="width: 50%">
                          <p class="m-0">{{ "tables.name" | translate }}</p>
                          <h4>
                            {{ feederAlert.food.name }}
                          </h4>
                        </div>
                        <div style="width: 50%">
                          <p class="m-0">{{ "tables.brand" | translate }}</p>
                          <h4>
                            {{ feederAlert.food.brand }}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col-12 col-md-6 col-lg-4 col-xl-3 text-left"
                  *ngIf="feeder && feeder.feeding_details && !hideAdminManagedViews()"
                >
                  <div class="card p-3 d-flex justify-content-center" style="min-height: 140px">
                    <div>
                      <h4 class="mb-0 mt-2">{{ "ration-modal.this-hour" | translate }}</h4>
                    </div>
                    <div class="mt-2" *ngIf="feeder.feeding_details">
                      <p class="m-0 mt-2">{{ "ration-modal.food-per-hour" | translate }}</p>
                      <b class="mt-2" style="font-size: 12px">
                        {{
                          feeder.feeding_details.percentage === 0
                            ? 0
                            : validateFeedRate(getRationKgs(), feeder.feeding_details.percentage)
                        }}
                        kgs -
                        {{
                          feeder.feeding_details.percentage
                            ? feeder.feeding_details.percentage.toFixed(2)
                            : 0
                        }}
                        %
                        {{ "ration-modal.distributed-among" | translate }}
                        {{
                          feederAlert && feeder.feeding_details
                            ? getActiveFeeders(
                                feederAlert.kgs_fed,
                                feeder.feeding_details.feeder_ration
                              )
                            : 0
                        }}
                        {{ "ration-modal.active-hoppers" | translate }}
                      </b>
                      <div class="d-flex justify-content-between mt-2">
                        <div style="width: 50%">
                          <p class="m-0">{{ "ration-modal.kg-per-unit" | translate }}</p>
                          <h4>
                            {{
                              (feederAlert && feeder.feeding_details
                                ? getKgsPerFeeder(
                                    getRationKgs(),
                                    feeder.feeding_details.percentage,
                                    feeder.feeding_details.feeder_ration
                                  )
                                : 0
                              ) | number : "1.2-2"
                            }}
                            kgs
                          </h4>
                        </div>
                        <div style="width: 50%">
                          <p class="m-0">{{ "admin.calibration.shots" | translate }}</p>
                          <h4>
                            {{
                              feeder.feeding_details
                                ? feeder.feeding_details.interval > 0
                                  ? 60 / feeder.feeding_details.interval
                                  : 0
                                : 0
                            }}
                          </h4>
                        </div>
                      </div>

                      <ng-container *ngIf="storageService.isAdmin()">
                        <p class="m-0">
                          {{ "ration-modal.feed-rate" | translate }}
                        </p>
                        <h4>
                          {{
                            feeder.feeding_details.feed_rate ? feeder.feeding_details.feed_rate : 0
                          }}
                          /
                          {{ feeder.dispenser.dosing_factor ? feeder.dispenser.dosing_factor : 0 }}
                        </h4>
                        <p class="m-0">
                          {{ "ration-modal.triggering-time" | translate }}
                        </p>
                        <h4>{{ feeder.feeding_details.ration_time }} d/seg</h4>
                      </ng-container>
                    </div>
                  </div>
                </div>
                <div
                  class="col-12 col-md-6 col-lg-4 col-xl-3 text-left"
                  *ngIf="feeder && (feeder.feeding_details || hasFeederReport())"
                >
                  <div class="card p-3 d-flex justify-content-center" style="min-height: 140px">
                    <div>
                      <h4 class="mb-0 mt-2">
                        {{ "ration-modal.ration" | translate }}
                      </h4>
                    </div>
                    <!-- Racion por equipo cuando el equipo trae su ultimo reporte -->
                    <div class="mt-2" *ngIf="hasFeederReport(); else pond_ration">
                      <div class="d-flex justify-content-between mt-2">
                        <div style="width: 50%">
                          <p class="m-0">{{ "ration-modal.amount-feeder" | translate }}</p>
                          <h4>
                            {{
                              getFeederRationPerUnit(feeder.last_feeding_report.kgs_fed)
                                | number : "1.2-2"
                            }}
                            kg
                          </h4>
                        </div>
                        <div style="width: 50%" *ngIf="feederAlert">
                          <p class="m-0">{{ "ration-modal.amount-pond" | translate }}</p>
                          <h4>{{ feederAlert.kgs_fed }} kg</h4>
                        </div>
                      </div>
                    </div>
                    <!-- Racion por estanque repartida entre equipos -->
                    <ng-template #pond_ration>
                      <div class="mt-2">
                        <div class="d-flex justify-content-between mt-2">
                          <div style="width: 50%">
                            <p class="m-0">{{ "ration-modal.total-kg" | translate }}</p>
                            <h4>{{ feederAlert.kgs_fed }} kg</h4>
                          </div>
                          <div style="width: 50%">
                            <p class="m-0">{{ "ration-modal.distributed-per-unit" | translate }}</p>
                            <h4>{{ feeder.feeding_details.feeder_ration.toFixed(2) }} kg</h4>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12" *ngIf="!feedingByAdmin">
              <div class="center flex-wrap mt-3 mb-3" style="gap: 10px">
                <button
                  class="btn btn-section"
                  *ngIf="feederAlert.diet"
                  [ngClass]="{ 'btn-primary': view === 'diet' }"
                  (click)="setData(feederAlert.diet)"
                >
                  <h4 class="mb-0 text-center">
                    {{ "ration-modal.diet" | translate }}
                  </h4>
                </button>
                <button
                  class="btn btn-section"
                  *ngIf="feeder.virtual_weight && permissions.view_virtual_weight"
                  (click)="view = 'food'"
                  [ngClass]="{ 'btn-primary': view === 'food' }"
                >
                  <h4 class="mb-0 text-center">
                    {{ "ration-modal.food" | translate }}
                  </h4>
                </button>
                <button
                  class="btn btn-section"
                  (click)="getSpeed(); view = 'speed'"
                  [ngClass]="{ 'btn-primary': view === 'speed' }"
                  *ngIf="validateVersionSpeed(feeder)"
                >
                  <h4 class="mb-0 text-center">
                    {{ "ration-modal.speed" | translate }}
                  </h4>
                </button>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="!feederAlert">
            <div class="center p-3">
              <h3 class="text-warning">{{ "ration-modal.no-feeding" | translate }}.</h3>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-template>
  </div>
</ng-template>
